<template>
  <global-modal
    :active="dialog.isActive"
    @toggleActive="toggleActive"
    classModal="w-full sm:w-3/5"
  >
    <!-- Title -->
    <section class="text-xl font-medium" slot="header">Update Sertifikat</section>

    <!-- Body -->
    <div class="w-full p-5">
      <!-- List current files -->
      <ul>
        <global-file-upload
          v-for="(item, index) in dialog.files"
          :key="index"
          :item="item"
        >
          <template slot="action">
            <vs-button
              radius
              color="danger"
              type="border"
              icon="icon-trash"
              icon-pack="feather"
              size="small"
              @click="handleOnRemove({ id: item.id, index })"
            ></vs-button>
          </template>
        </global-file-upload>
        <!-- Action -->
      </ul>

      <!-- Upload new files -->
      <vs-upload @change="handleOnFileChange" ref="upload" />
    </div>

    <!-- Footer -->
    <section class="p-4 flex justify-end" slot="footer">
      <div>
        <vs-button
          id="confirmAccept"
          class="mx-1"
          color="primary"
          type="filled"
          @click="handleOnSubmit"
        >
          Update
        </vs-button>
        <vs-button
          id="confirmCancel"
          class="mx-1"
          color="danger"
          type="border"
          @click="handleOnCancel"
        >
          Cancel
        </vs-button>
      </div>
    </section>
  </global-modal>
</template>

<script>
import {UPDATE} from '@/query/pengguna';
export default {
  props: {
    penggunaId: {
      type: [Number, String],
      required: true
    },
    dokumen: {
      type: Array
    }
  },
  data() {
    return {
      dialog: {
        isActive: false,
        files: []
      },
      formValues: {
        files: [],
        removeIds: []
      },
      convertedCerts: ''
    };
  },
  methods: {
    handleOnFileChange() {
      const files = this.$refs.upload.filesx;
      this.convertToBase64(files[0]);
    },
    convertToBase64(fileInput){
      var reader = new FileReader();
      reader.readAsDataURL(fileInput);
      reader.onload = () => {
        console.log(reader.result);
        this.convertedCerts = reader.result.substr(reader.result.indexOf(',') + 1);
      };
      reader.onerror = (error) => {
        console.log(error);
      };
    },
    async handleOnSubmit() {
      let check = this.checkFormValue();
      if(check){
        try {
          await this.postDocuments();
          this.toggleActive(false);
          this.submitCallback();
          this.$vs.notify({
            title: "Sukses",
            text: "Berhasil memperbaharui data sertifikat pengguna.",
            color: "success"
          });
        } catch (error) {
          console.error(error);
          this.$vs.notify({
            title: "Gagal",
            text: "Update sertifikat pengguna gagal.",
            color: "danger"
          });
        }
      }
    },
    checkFormValue(){
      if(this.convertedCerts.length < 1){
        this.$vs.notify({
          title: "Gagal",
          text: "Silahkan lengkapi form terlebih dahulu !",
          color: "danger"
        });
        return false;
      }
      else{
        return true;
      }
    },
    async postDocuments(){
      await this.$apollo.mutate({
        mutation : UPDATE,
        variables : {
          id : this.penggunaId,
          input : {
            sertifikat : this.convertedCerts
          }
        }
      })
    },

    initDialogValues() {
      this.dialog.files = [...this.dokumen];
    },

    handleOnCancel() {
      this.toggleActive(false);
    },

    handleOnRemove({ id, index }) {
      this.formValues.removeIds.push(id);
      this.dialog.files.splice(index, 1);
    },

    submitCallback() {
      this.$emit("submitCallback", true);
    },

    toggleActive(isActive) {
      this.dialog.isActive = isActive;
      this.initDialogValues();
      this.resetFormValues();
    },

    resetFormValues() {
      this.formValues.files = [];
      this.formValues.removeIds = [];
    }
  }
};
</script>
